import { Alert } from '@zenid/web';
import { EmailResendDialog } from '../EmailResendDialog';
import { css } from '../../../../../../../styled-system/css';
import type { EmailResendDialogProps } from '#/features/myPage/hooks/useEmailResendDialog';
import type { VerificationEmailProps } from '#/features/myPage/hooks/useVerificationEmail';

export type ResendEmailAlertProps = {
  email: string;
  verificationEmail: VerificationEmailProps;
  emailResendDialog: EmailResendDialogProps;
};

export function ResendEmailAlert({
  email,
  verificationEmail: { isSuccess },
  emailResendDialog: { openDialogWithSendVerificationEmail, setIsOpenDialog, isOpenDialog },
}: ResendEmailAlertProps) {
  return (
    <>
      {isSuccess ? (
        <Alert type="info">
          <p className={css({ textStyle: 'body.m.default' })}>
            認証確認メールを再送しました。メール記載のURLからメールアドレス認証を完了してください。
            <br />
            認証確認メールが届いていない場合は
            <a
              href="https://help.zenid.jp/hc/ja"
              className={css({ textDecoration: 'underline', cursor: 'pointer' })}
              target="_blank"
              rel="noopener noreferrer"
            >
              よくある質問
            </a>
            をご確認ください。
          </p>
        </Alert>
      ) : (
        <Alert type="warning">
          <p className={css({ textStyle: 'body.m.default' })}>
            ご登録のメールアドレス宛にお送りした認証確認メールより、メールアドレスの認証を完了してください。&nbsp;
            <button
              className={css({ textDecoration: 'underline', cursor: 'pointer' })}
              onClick={openDialogWithSendVerificationEmail}
            >
              メールを再送する
            </button>
          </p>
        </Alert>
      )}
      <EmailResendDialog
        email={email}
        onOpenChange={setIsOpenDialog}
        open={isOpenDialog}
        onClickOk={() => setIsOpenDialog(false)}
      />
    </>
  );
}
